'use es6';

export default ((...functions) => arg => {
  let result = arg;
  for (let i = functions.length - 1; i >= 0; i--) {
    result = functions[i](result);
  }
  return result;
});